import React, { useState } from 'react';

function NamePrompt({ onSubmit }) {
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
    }
  };

  return (
    <div className="name-prompt-overlay">
      <div className="name-prompt-card">
        <h2>Enter Your Name</h2>
        <p>This will be visible to others in the room</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your name..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={20}
            autoFocus
            className="name-input"
          />
          <button type="submit" disabled={!name.trim()} className="btn btn-primary btn-large">
            Join Room
          </button>
        </form>
      </div>
    </div>
  );
}

export default NamePrompt;